import { Component, OnInit, HostListener } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { RegistroService } from './registro.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
    private lastActivity: number = Date.now();
    private readonly ACTIVITY_TIMEOUT = 1 * 60 * 500;
    private tokenExpirationTime = 0;

    constructor(
        private readonly keycloak: KeycloakService,
        private readonly router: Router,
        private readonly registroService: RegistroService
    ) {
        const keycloakInstance = this.keycloak.getKeycloakInstance();
        this.tokenExpirationTime = keycloakInstance.tokenParsed.exp * 1000;
    }
    tituloContenido = 'Producto';
    descripcionGeneral = '';

    @HostListener('window:mousemove')
    @HostListener('window:keypress')
    @HostListener('window:click')
    onUserActivity() {
        this.lastActivity = Date.now();
    }

    async ngOnInit() {
        setInterval(() => {
            this.checkTokenAndHandleSession();
        }, 10000);
    }

    private async checkTokenAndHandleSession() {
        const timeIdle = Date.now() - this.lastActivity;
        const timeRemaining = this.tokenExpirationTime - Date.now();

        if (timeRemaining <= 0) {
            await this.showSessionExpiredAlert();
        } else if (timeIdle < this.ACTIVITY_TIMEOUT) {
            try {
                const refreshed = await this.keycloak.updateToken(500);

                if (refreshed) {
                    const keycloakInstance =
                        this.keycloak.getKeycloakInstance();
                    if (
                        keycloakInstance.tokenParsed &&
                        keycloakInstance.tokenParsed.exp
                    ) {
                        const newExpirationTime =
                            keycloakInstance.tokenParsed.exp * 1000;

                        if (newExpirationTime > this.tokenExpirationTime) {
                            this.tokenExpirationTime = newExpirationTime;
                        }
                    }
                }
            } catch (error) {
                console.error('Error al renovar token:', error);
                await this.keycloak.login();
            }
        }
    }

    private async showSessionExpiredAlert() {
        await Swal.fire({
            title: 'Sesión expirada',
            text: 'Su sesión ha expirado por inactividad. Será redirigido al inicio de sesión.',
            icon: 'warning',
            confirmButtonText: 'Aceptar',
        });

        // Limpiar estado de sesión para que al re-ingresar no quede
        // la empresa/eslabón/menú de la sesión anterior.
        this.registroService.limpiarEstadoSesion();
        await this.router.navigate(['/inicio']);
        await this.keycloak.logout();
    }
}
